export default "__VITE_ASSET__e6OgEyoh__"